import React, { ReactNode, useState, useEffect } from 'react';
import useWindowPositionTop from 'hooks/useWindowPositionTop';
import titleImage from 'assets/img/I_speak.png'
import tutorImage from 'assets/img/tutor-image.jpg'
import img from 'assets/img/IMG_9314-1.jpg'
// import celt from '@/src/assets/img/tefl-tesol-celt.jpg'
// import ct from '@/src/assets/img/tefl-tesol-ct.jpg'
import importanceImage from 'assets/img/ExclamationMark.jpg'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { scrollToId } from '../../utils/scrollToSection'; // ваш util для скролла

export default function HomePage () {
    useWindowPositionTop();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const scrollTo = params.get('scrollTo');

        if (scrollTo) {
        // Немного ждем, чтобы элемент гарантированно отрендерился
        setTimeout(() => {
            scrollToId(scrollTo);
        }, 100);
        }
    }, [location]);

    return (
        <>
            <main className="main">
                <Section id={'tutor'} className={'main__tutor tutor'}>
                    <div className="tutor__container container">
                        {/* <RunningText className={'tutor__text-running'}>
                            Только до 15 ноября провожу донабор на занятия в парах и в мини-группах
                        </RunningText>
                        <CountdownTimer className={'tutor__timer timer red'}/> */}
                        <div className="tutor__wrapper">
                            <h1 className="tutor__title dark">Онлайн-репетитор по <span className="red">АНГЛИЙСКОМУ ЯЗЫКУ</span></h1>
                            <div className="tutor__image-block">
                                <div className='tutor__image ibg'>
                                    <img src={tutorImage} alt='фото'/>
                                </div>
                                <div className='tutor__image ibg'>
                                    <img src={titleImage} alt='фото'/>
                                </div>
                            </div>
                            <h2 className="tutor__subtitle section-title blue">Just Speak, learn, and think in English!</h2>
                            <div className="tutor__description blue">
                                <p className="tutor__text tutor__text-highlight">Просто говори, учи и думай на английском!</p>
                                <p className="tutor__text section-text dark">Уже с первых занятий Вы или Ваш ребёнок начнёте говорить простыми предложениями. <strong>Это реально!</strong></p>
                            </div>
                            <div className="tutor__features dark">
                                <p className="tutor__feature">Без толстых учебников, без воды, без нудных длительных упражнений и прочей фигни.</p>
                                <p className="tutor__feature">Только системные знания!</p>
                                <div className="tutor__feature-highlight feature-highlight section-text red">
                                    <svg viewBox="0 0 1024 1024" className="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M188.497 377.512h647.006V960H188.497z" fill="#FF3B30"></path>
                                            <path d="M467.308 399.028h52.471V960h-52.471z" fill="#070707"></path>
                                            <path d="M485.764 399.028h52.471V960h-52.471z" fill="#070707"></path>
                                            <path d="M719.989 82.722c-35.235-35.24-108.329-19.276-163.256 35.653-20.618 20.618-35.743 43.795-44.733 66.568-8.991-22.773-24.116-45.95-44.734-66.568-54.928-54.929-128.022-70.893-163.257-35.653-35.235 35.234-19.273 108.331 35.653 163.256 54.929 54.929 128.022 70.893 163.257 35.653 3.602-3.6 6.534-7.69 9.079-12.021 2.546 4.331 5.476 8.421 9.08 12.021 35.237 35.24 108.329 19.276 163.257-35.653 54.929-54.925 70.891-128.022 35.654-163.256z" fill="#0DB14B"></path>
                                            <path d="M502.361 281.073c-18.915 18.914-63.108 5.389-98.708-30.21-35.601-35.606-49.127-79.798-30.213-98.713 18.916-18.914 63.108-5.388 98.709 30.216 13.636 13.634 23.961 28.517 30.536 42.767-0.939 14.986 1.32 28.883 7.132 40.628-1.191 5.962-3.443 11.297-7.456 15.312z"></path>
                                            <path d="M650.67 208.632c-5.876 12.562-14.915 25.53-26.306 37.759h59.533c0.143-0.145 0.296-0.27 0.44-0.415a211.524 211.524 0 0 0 29.745-37.344H650.67z"></path>
                                            <path d="M521.314 225.132c2.512-5.442 5.737-10.976 9.32-16.5h-37.268c3.581 5.524 6.808 11.058 9.32 16.5-0.465 7.399-0.131 14.518 1.005 21.259h16.618c1.137-6.741 1.47-13.859 1.005-21.259z"></path>
                                            <path d="M379.208 221.194l-58.869 2.524c8.079 12.908 7.534 10.471 19.326 22.258 0.143 0.145 0.296 0.27 0.44 0.415h59.533c-11.393-12.228-14.554-12.635-20.43-25.197z"></path>
                                            <path d="M107.621 246.39h808.758v217.144H107.621z" fill="#FF3B30"></path>
                                            <path d="M834.51 569.946l-646.033-73.822v-32.59H834.51z" fill="#070707"></path>
                                        </g>
                                    </svg>
                                    <p>Бесплатно узнай свой примерный уровень английского и <span>получи в подарок топ 40 разговорных фраз.</span></p>
                                </div>
                                <div className="tutor__button-cta button-cta section-text">
                                    <a href="https://forms.gle/pJPuLbKT1Z8G49cKA" target="_blank" rel="noopener noreferrer">Записаться</a>
                                </div>
                            </div>
                            <div className="tutor__methods">
                                <p className="tutor__method section-text">В своей практике я применяю сразу несколько международных методов обучения английскому языку.</p>
                                <p className="tutor__method section-text">И прежде всего <strong>естественный (натуральный) метод обучения языку</strong>, как в детстве ребёнок изучает родной язык.</p>
                            </div>
                            <div className="tutor__adv adv">
                                <div className="adv__item item-adv">
                                    <span className="red">20+</span>
                                    <p>лет опыта работы с иностранцами</p>
                                </div>
                                <div className="adv__item item-adv">
                                    <span className="red">11+</span>
                                    <p>лет практики преподавания оффлайн и онлайн​</p>
                                </div>
                                <div className="adv__item item-adv">
                                    <span className="red">400+</span>
                                    <p>Учеников уже прошли мои курсы и поступили в вузы мечты​</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Section>
                <Section id={'teacher'} className={'main__teacher teacher'}>
                    <div className='teacher__container container'>
                        <h2 className='teacher__title section-title blue'>
                            Кто я? Или почему мне можно доверять?
                        </h2>
                        <div className='teacher__wrapper'>
                            <div className='teacher__image ibg'>
                                <img src={img} alt='фото' />
                            </div>
                            <div className='teacher__text'>
                                <p className='teacher__description blue'>
                                    <svg fill="#00ff00" viewBox="0 0 24 24" className='icon' xmlns="http://www.w3.org/2000/svg" stroke="#00ff00">
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path fillRule="evenodd" d="M10.67,15.09 L12.05,13.69 L12.55,14.20 L20.62,6 L22,7.40 L12.55,17 L10.67,15.09 Z M6.55,14.20 L14.62,6 L16,7.40 L6.55,17 L1.97,12.35 L3.35,10.95 L6.55,14.20 Z"></path>
                                        </g>
                                    </svg>
                                    <span>Я — переводчик-синхронист с более чем 20-летним опытом устного последовательного и синхронного перевода.</span>
                                </p>
                                <p className='teacher__description blue'>
                                    <svg fill="#00ff00" viewBox="0 0 24 24" className='icon' xmlns="http://www.w3.org/2000/svg" stroke="#00ff00">
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path fillRule="evenodd" d="M10.67,15.09 L12.05,13.69 L12.55,14.20 L20.62,6 L22,7.40 L12.55,17 L10.67,15.09 Z M6.55,14.20 L14.62,6 L16,7.40 L6.55,17 L1.97,12.35 L3.35,10.95 L6.55,14.20 Z"></path>
                                        </g>
                                    </svg>
                                    <span>Обладаю международным сертификатом TEFL-TESOL с отличием, что позволяет преподавать английский язык во всех странах мира.</span>
                                </p>
                                <p className='teacher__description blue'>
                                    <svg fill="#00ff00" viewBox="0 0 24 24" className='icon' xmlns="http://www.w3.org/2000/svg" stroke="#00ff00">
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path fillRule="evenodd" d="M10.67,15.09 L12.05,13.69 L12.55,14.20 L20.62,6 L22,7.40 L12.55,17 L10.67,15.09 Z M6.55,14.20 L14.62,6 L16,7.40 L6.55,17 L1.97,12.35 L3.35,10.95 L6.55,14.20 Z"></path>
                                        </g>
                                    </svg>
                                    <span>Обучаю английскому на основе современных фильмов и мультфильмов, так что скучать не придётся.</span>
                                </p>
                                <p className='teacher__price dark'>Обучение на любом из моих курсов по доступным ценам. {'(от 600 р.)'}</p>
                            </div>
                            {/* <div className='teacher__certificates'>
                                <div className='teacher__certificate'>
                                    <Image src={celt} alt='certificate image' priority />
                                </div>
                                <div className='teacher__certificate'>
                                    <Image src={ct} alt='certificate image' priority />
                                </div>
                            </div> */}
                        </div>
                    </div>
                </Section>
                <Section id={'lesson'} className={'main__lesson lesson'}>
                    <div className="lesson__container container">
                        <h2 className="lesson__title section-title blue">КАК ПРОХОДЯТ ЗАНЯТИЯ</h2>
                        <h3 className="lesson__format section-text dark">
                            <span>Занятия ОНЛАЙН по Телемост.</span>
                        </h3>
                        <div className="lesson__types section-text dark">
                            <p className='lesson__type'>
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="42"
                                        height="42"
                                        fill="#2b3881"
                                        className="bi bi-person-check-fill"
                                        viewBox="0 0 16 16"
                                        >
                                        <path
                                            fillRule="evenodd"
                                            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                                            fill="#2b3881"
                                        />
                                        <path
                                            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                            fill="#2b3881"
                                        />
                                    </svg>
                                </span>
                                <span className='red'>Индивидуально</span>
                            </p>
                            <p className='lesson__type'>
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="42"
                                        height="42"
                                        fill="#2b3881"
                                        className="bi bi-person-check-fill"
                                        viewBox="0 0 16 16"
                                        >
                                        <path
                                            fillRule="evenodd"
                                            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                                            fill="#2b3881"
                                        />
                                        <path
                                            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                            fill="#2b3881"
                                        />
                                    </svg>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="42"
                                        height="42"
                                        fill="#2b3881"
                                        className="bi bi-person-check-fill"
                                        viewBox="0 0 16 16"
                                        >
                                        <path
                                            fillRule="evenodd"
                                            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                                            fill="#2b3881"
                                        />
                                        <path
                                            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                            fill="#2b3881"
                                        />
                                    </svg>
                                </span>
                                <span className='red'>В парах</span>
                            </p>
                            <p className='lesson__type'>
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="42"
                                        height="42"
                                        fill="#2b3881"
                                        className="bi bi-person-check-fill"
                                        viewBox="0 0 16 16"
                                        >
                                        <path
                                            fillRule="evenodd"
                                            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                                            fill="#2b3881"
                                        />
                                        <path
                                            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                            fill="#2b3881"
                                        />
                                    </svg>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="42"
                                        height="42"
                                        fill="#2b3881"
                                        className="bi bi-person-check-fill"
                                        viewBox="0 0 16 16"
                                        >
                                        <path
                                            fillRule="evenodd"
                                            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                                            fill="#2b3881"
                                        />
                                        <path
                                            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                            fill="#2b3881"
                                        />
                                    </svg>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="42"
                                        height="42"
                                        fill="#2b3881"
                                        className="bi bi-person-check-fill"
                                        viewBox="0 0 16 16"
                                        >
                                        <path
                                            fillRule="evenodd"
                                            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                                            fill="#2b3881"
                                        />
                                        <path
                                            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                            fill="#2b3881"
                                        />
                                    </svg>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="42"
                                        height="42"
                                        fill="#2b3881"
                                        className="bi bi-person-check-fill"
                                        viewBox="0 0 16 16"
                                        >
                                        <path
                                            fillRule="evenodd"
                                            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                                            fill="#2b3881"
                                        />
                                        <path
                                            d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                            fill="#2b3881"
                                        />
                                    </svg>
                                </span>
                                <span className='red'>В мини-группах</span>
                            </p>
                        </div>
                        <div className="lesson__frequency section-text dark">2 раза в неделю по 60 минут</div>
                    </div>
                </Section>
                <Section id={'courses'} className={'main__courses courses'}>
                    <div className="courses__container container">
                        <h2 className='courses__title section-title blue'>МОИ КУРСЫ ОНЛАЙН:</h2>
                        <CourseList/>
                        <div className="courses__feature-highlight feature-highlight section-text red">
                            <svg viewBox="0 0 1024 1024" className="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M188.497 377.512h647.006V960H188.497z" fill="#FF3B30"></path>
                                    <path d="M467.308 399.028h52.471V960h-52.471z" fill="#070707"></path>
                                    <path d="M485.764 399.028h52.471V960h-52.471z" fill="#070707"></path>
                                    <path d="M719.989 82.722c-35.235-35.24-108.329-19.276-163.256 35.653-20.618 20.618-35.743 43.795-44.733 66.568-8.991-22.773-24.116-45.95-44.734-66.568-54.928-54.929-128.022-70.893-163.257-35.653-35.235 35.234-19.273 108.331 35.653 163.256 54.929 54.929 128.022 70.893 163.257 35.653 3.602-3.6 6.534-7.69 9.079-12.021 2.546 4.331 5.476 8.421 9.08 12.021 35.237 35.24 108.329 19.276 163.257-35.653 54.929-54.925 70.891-128.022 35.654-163.256z" fill="#0DB14B"></path>
                                    <path d="M502.361 281.073c-18.915 18.914-63.108 5.389-98.708-30.21-35.601-35.606-49.127-79.798-30.213-98.713 18.916-18.914 63.108-5.388 98.709 30.216 13.636 13.634 23.961 28.517 30.536 42.767-0.939 14.986 1.32 28.883 7.132 40.628-1.191 5.962-3.443 11.297-7.456 15.312z"></path>
                                    <path d="M650.67 208.632c-5.876 12.562-14.915 25.53-26.306 37.759h59.533c0.143-0.145 0.296-0.27 0.44-0.415a211.524 211.524 0 0 0 29.745-37.344H650.67z"></path>
                                    <path d="M521.314 225.132c2.512-5.442 5.737-10.976 9.32-16.5h-37.268c3.581 5.524 6.808 11.058 9.32 16.5-0.465 7.399-0.131 14.518 1.005 21.259h16.618c1.137-6.741 1.47-13.859 1.005-21.259z"></path>
                                    <path d="M379.208 221.194l-58.869 2.524c8.079 12.908 7.534 10.471 19.326 22.258 0.143 0.145 0.296 0.27 0.44 0.415h59.533c-11.393-12.228-14.554-12.635-20.43-25.197z"></path>
                                    <path d="M107.621 246.39h808.758v217.144H107.621z" fill="#FF3B30"></path>
                                    <path d="M834.51 569.946l-646.033-73.822v-32.59H834.51z" fill="#070707"></path>
                                </g>
                            </svg>
                            <p>Бесплатно узнай свой примерный уровень английского и <span>получи в подарок топ 40 разговорных фраз.</span></p>
                        </div>
                        <div className="courses__button-cta button-cta section-text">
                            <a href="https://forms.gle/pJPuLbKT1Z8G49cKA" target="_blank" rel="noopener noreferrer">Записаться</a>
                        </div>
                    </div>
                </Section>
                <Section id={'target-audience'} className={'main__target-audience target-audience'}>
                    <div className="target-audience__container container">
                        <h2 className="target-audience__title section-title blue">Для кого?</h2>
                        <ul className="target-audience__list section-text dark">
                            <li className="target-audience__item">Для начинающих</li>
                            <li className="target-audience__item">Для тех, кто хочет улучшить разговорные навыки</li>
                            <li className="target-audience__item">Для туристов</li>
                            <li className="target-audience__item">Для тех, кто никогда не изучал английский и хочет заговорить на нем</li>
                            <li className="target-audience__item">Для тех, кто изучал английский в школе и институте, но так и не заговорил на нем</li>
                            <li className="target-audience__item">Для тех, кто планирует поехать в отпуск и нужно срочно изучить английский язык</li>
                        </ul>
                    </div>
                </Section>
                <Section id={'benefits'} className={'main__benefits benefits'}>
                    <div className="benefits__container container">
                        <h2 className="benefits__title section-title blue">Вы получите:</h2>
                        <ul className="benefits__list section-text dark">
                            <li className="benefits__item">Вы или Ваш ребёнок научитесь говорить так, как говорят носители и будете понимать речь иностранцев;</li>
                            <li className="benefits__item">Вы или Ваш ребёнок избавитесь от синдрома «понимаю, но ничего сказать не могу»;</li>
                            <li className="benefits__item">Вы или Ваш ребёнок сможете смотреть фильмы в оригинале;</li>
                            <li className="benefits__item">Вы почувствуете уверенность при общении!</li>
                        </ul>
                    </div>
                </Section>
                <Section id={'importance'} className={'main__importance importance'}>
                    <div className="importance__container container">
                        <div className="importance__wrapper">
                            <div className='importance__image ibg'>
                                <img src={importanceImage} alt='фото' />
                            </div>
                            <h2 className="importance__title section-title dark"><span className='red'>ВАЖНО!</span></h2>
                            <h3 className="importance__title section-title dark">Ваш результат зависит не только от меня, но и лично <span className='red'>от Вас!</span></h3>
                        </div>
                        <div className="importance__feature-highlight feature-highlight section-text red">
                            <svg viewBox="0 0 1024 1024" className="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M188.497 377.512h647.006V960H188.497z" fill="#FF3B30"></path>
                                    <path d="M467.308 399.028h52.471V960h-52.471z" fill="#070707"></path>
                                    <path d="M485.764 399.028h52.471V960h-52.471z" fill="#070707"></path>
                                    <path d="M719.989 82.722c-35.235-35.24-108.329-19.276-163.256 35.653-20.618 20.618-35.743 43.795-44.733 66.568-8.991-22.773-24.116-45.95-44.734-66.568-54.928-54.929-128.022-70.893-163.257-35.653-35.235 35.234-19.273 108.331 35.653 163.256 54.929 54.929 128.022 70.893 163.257 35.653 3.602-3.6 6.534-7.69 9.079-12.021 2.546 4.331 5.476 8.421 9.08 12.021 35.237 35.24 108.329 19.276 163.257-35.653 54.929-54.925 70.891-128.022 35.654-163.256z" fill="#0DB14B"></path>
                                    <path d="M502.361 281.073c-18.915 18.914-63.108 5.389-98.708-30.21-35.601-35.606-49.127-79.798-30.213-98.713 18.916-18.914 63.108-5.388 98.709 30.216 13.636 13.634 23.961 28.517 30.536 42.767-0.939 14.986 1.32 28.883 7.132 40.628-1.191 5.962-3.443 11.297-7.456 15.312z"></path>
                                    <path d="M650.67 208.632c-5.876 12.562-14.915 25.53-26.306 37.759h59.533c0.143-0.145 0.296-0.27 0.44-0.415a211.524 211.524 0 0 0 29.745-37.344H650.67z"></path>
                                    <path d="M521.314 225.132c2.512-5.442 5.737-10.976 9.32-16.5h-37.268c3.581 5.524 6.808 11.058 9.32 16.5-0.465 7.399-0.131 14.518 1.005 21.259h16.618c1.137-6.741 1.47-13.859 1.005-21.259z"></path>
                                    <path d="M379.208 221.194l-58.869 2.524c8.079 12.908 7.534 10.471 19.326 22.258 0.143 0.145 0.296 0.27 0.44 0.415h59.533c-11.393-12.228-14.554-12.635-20.43-25.197z"></path>
                                    <path d="M107.621 246.39h808.758v217.144H107.621z" fill="#FF3B30"></path>
                                    <path d="M834.51 569.946l-646.033-73.822v-32.59H834.51z" fill="#070707"></path>
                                </g>
                            </svg>
                            <p>Бесплатно узнай свой примерный уровень английского и <span>получи в подарок топ 40 разговорных фраз.</span></p>
                        </div>
                        <div className="importance__button-cta button-cta section-text">
                            <a href="https://forms.gle/pJPuLbKT1Z8G49cKA" target="_blank" rel="noopener noreferrer">Записаться</a>
                        </div>
                    </div>
                </Section>
                <Section id={'subscribe'} className={'main__subscribe subscribe'}>
                    <div className="subscribe__container container">
                        <h2 className="subscribe__title section-title dark">Прокачай свой разговорный английский!</h2>
                        <p className="subscribe__text section-text dark">Подписывайся на мой YouTube-канал:</p>
                        <div className="subscribe__youtube-logo youtube-logo section-text">
                            <a href="https://youtube.com/@rostenglish-julierostokina?si=i_JxAUpAV2WnL69u" rel="noopener noreferrer" target="_blank">You<span>Tube</span></a>
                        </div>
                        <p className="subscribe__text section-text dark">И подписывайся на мой телеграм-канал:</p>
                        <div className='subscribe__telegram'>
                            <a href="https://t.me/rostenglish" target="_blank" rel="noopener noreferrer">Подписаться на Telegram</a>
                        </div>
                    </div>
                </Section>
                <Section id={'review'} className={'main__review review'}>
                    <div className="review__container container">
                        <h2 className="review__title section-title blue">Отзывы учеников</h2>
                        <FeedbackList className={'review__list'}/>
                    </div>
                </Section>
                {/* <Section id={'test'} className={'main__test test'}>
                    <div className="test__container container">
                        <EnglishTest/>
                    </div>
                </Section> */}
                <SocialMediaLink/>
            </main>
        </>
    )
}
interface SectionProps {
    id: string;
    className?: string;
    children: ReactNode;
}

const Section: React.FC<SectionProps> = ({ id, className, children }) => {
    return (
        <section id={id} className={className}>
            {children}
        </section>
    );
};

// const RunningText = ({className, children }) => {
//     return (
//         <div className={`${className} running-text-container`}>
//             <span className="running-text blue">
//                 {children}
//             </span>
//         </div>
//     );
// };
// Course type
interface Course {
    id: string | number;
    image: string;
    title: string;
    to: string;
}

const CourseList: React.FC = () => {
    const courses: Course[] = [
        {
            id: '1',
            image: require("../../assets/coursesImage/CHILDREN.jpg"),
            title: 'Базовый курс для детей от 10 до 17 лет',
            to: 'Basic-English-course-for-children'
        },
        {
            id: '2',
            image: require("../../assets/coursesImage/ADULTS.jpg"),
            title: 'Базовый курс английского языка для взрослых',
            to: 'Basic-English-course-for-Adults'
        },
        {
            id: '3',
            image: require("../../assets/coursesImage/CONVERSATIONAL.jpg"),
            title: 'Разговорный английский',
            to: 'Spoken-English'
        },
        {
            id: '4',
            image: require("../../assets/coursesImage/EXPRESS.jpg"),
            title: 'Экспресс-курс для выезда за границу',
            to: 'English-Express-Course-for-Traveling-Abroad'
        },
        {
            id: '5',
            image: require("../../assets/coursesImage/TheOGE.jpg"),
            title: 'Курс подготовки к ОГЭ.',
            to: 'The-course-of-preparation-for-the-OGE'
        },
        {
            id: '6',
            image: require("../../assets/coursesImage/TheUSE.jpg"),
            title: 'Курс подготовки к ЕГЭ по английскому',
            to: 'English-Exam-Preparation-Course'
        },
        {
            id: '7',
            image: require("../../assets/coursesImage/BUSINESS.jpg"),
            title: 'Бизнес-курс',
            to: 'Business-course'
        },
    ];
    return (
        <div>
            <div className="courses-grid">
                {courses.map((course) => (
                    <Link 
                        key={course.id}
                        to={`/${course.to}`}  // <-- обязательно укажите путь здесь
                        aria-label={`Перейти к курсу ${course.title}`}>
                        <div className='course-card'>
                            <img src={course.image} alt={course.title} className="course-card__image" />
                        </div>
                    </Link>
                ))}
                <style>{`
                    .courses-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                        gap: 20px;
                        padding: 20px;
                    }
                    .course-card {
                        cursor: pointer;
                        border-radius: 8px;
                        overflow: hidden;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                        transition: transform 0.2s ease, box-shadow 0.2s ease;
                        outline: none;
                        object-fit: cover;
                    }
                    .course-card:focus,
                    .course-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                    }
                    .course-card__image {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        display: block;
                    }
                `}</style>
            </div>
        </div>
    );
};

// Feedback type
interface FeedbackData {
    id: string;
    image: string;
    firstName: string;
    lastName: string;
    status?: string;
    age?: number;
    text: string;
    socialLink?: string;
}

const feedBackData: FeedbackData[] = [
    {
        id: '1',
        image: require("../../assets/feedBackImage/videman.jpg"),
        firstName: 'Евгений',
        lastName: 'Видеман',
        text:'Меня зовут Евгений. По профессии я - ветеринарный врач. В 2017 году передо мной встала задача срочно изучить английский язык-это было необходимым условием для моего профессионального роста. До этого я изучал немецкий, а английского языка совсем не знал и никогда раньше не учил. Времени на изучение языка у меня было крайне мало, всего 3 месяца, и многие репетиторы из-за этого отказывались со мной работать. Юлия согласилась. Занимались мы всего два раза в неделю, чаще я не мог в силу своей загруженности на работе. Внезапно день сдачи экзамена перенесли на месяц раньше, чем изначально планировалось. Я к тому времени прошёл всего 16 занятий и успел лишь научиться строить простые предложения, освоил несколько основных грамматических структур, научился читать и выучил рассказ-презентацию о себе (кстати, после последняя фраза о том, что для меня это не просто работа, но моё призвание- сыграла ключевую роль на экзамене) . Не смотря на то, что я не прошёл курс английского до конца, я всё- таки решил рискнуть. И я не просто сдал письменную и устную часть экзамена, но и набрал необходимое количество баллов для прохождения на следующий этап конкурса. Это была настоящая победа для меня на тот момент! Скажу больше. Из-за большого водоворота событий в моей жизни в то время, я совсем перестал заниматься английским, и вернулся к нему лишь спустя 3 года, когда требовалось сдавать вступительный экзамен в магистратуру в августе 2020 Я всего лишь за пару часов освежил знания по своим записям наших занятий и этого вновь оказалось достаточным для того, чтобы сдать экзамен и поступить! На экзамене меня похвалила экзаменатор за моё произношение) Словом, я рекомендую всем, кому нужно изучить английский за короткий срок , обратиться к Юлии',
        socialLink: 'https://vk.com/id346649815',
    },
    {
        id: '2',
        image: require("../../assets/feedBackImage/artem.jpg"),
        firstName: 'Артём',
        lastName: 'Зяблицкий',
        text:'Я учился в 9 классе, когда начал заниматься английским языком с Юлией. В будущем свою профессию хочу связать с компьютером (дизайн, программирование и др.) Английский язык решил учить потому что считаю, что это пригодится в моей будущей профессии, а также я хочу понимать людей в любой точке мира, и чтобы они понимали всё, что я говорю. До того как начал заниматься с Юлией Викторовной, я плохо знал английскую грамматику и не мог понимать английскую речь на слух. Самое главное, что меня продвинуло в английском - это чёткое понимание разницы английских времён. Я смог разобраться во всех 26 временах английских глаголов достаточно быстро и без труда, благодаря тому, что Юлия Викторовна всё объясняет доступно и на простых примерах. Сейчас, получив такую базу знаний и методику заучивания слов без зубрёжки, я совершенствую свой английский лишь изучая новые слова. Я изучал английский язык с разными репетиторами, Юлия Викторовна - очень позитивная и объясняет всё настолько понятно, что всё становится лёгким и простым!',
        socialLink: 'https://vk.com/the.art.nick',
    },
    {
        id: '3',
        image: require("../../assets/feedBackImage/Matwey.jpg"),
        firstName: 'Матвей',
        lastName: 'Бондаренко',
        text:'Когда я только пришёл на занятия к Юлии, у меня в школе были двойки и тройки по английскому языку. Я путал формы неправильных глаголов и не понимал разницы времён Действительного залога. Уже спустя несколько занятий, я стал увереннее, и оценки в школе улучшилились до 4 и 5. А 6 класс я закончил с твёрдой 5-кой за год. Я не только научился правильно определять времена глаголов в упражнениях, но и у меня стало хорошо получаться переводить тексты самому. Я настолько стал уверенным в английском языке, что по окончании 6 класса я решил сам попробовать заниматься в школе без помощи репетитора. В 7 классе у меня хорошие оценки 4 и 5 без помощи репетитора. Поэтому я рекомендую ребятам, у кого сложности с английским, заниматься с Юлией. Она очень доступно всё объясняет, к тому же на каждом занятии мы обсуждали разные темы на английском языке и в конце каждого урока смотрели мультфильмы без перевода.',
        socialLink: 'https://vk.com/id871915769',
    },
    {
        id: '4',
        image: require("../../assets/feedBackImage/Sofia.jpg"),
        firstName: 'София',
        lastName: 'Комиссарова',
        text:'1. До прихода к Юлии я вообще не знала английский, точнее в обиходе было пару десятков слов, а о том, что такое грамматика английского языка - я знала только понаслышке. 2. ⁠Лично для меня Юлия вполне понятно объясняла грамматику, доказательством этому может быть тот факт, что я все ещё её хорошо помню, и что в целом я быстро понимала где и как я должна писать, имхо. 3. ⁠После занятий я продолжила практиковать английский на слух, по фильмам, сериалам и музыке (по рекомендации Юлии). В данный момент продолжаю повторять и учить дальше английский в учебном заведении. Часть разговорных выражений запомнилась, часть нет, но это моя вина, я особо их не повторяла, а применять их на практике часто мне пока негде. 4. ⁠Да, определенно я порекомендовала бы и друзьям, и знакомым и незнакомым. Почему? Ответ прост: Юлия очень просто и доходчиво объясняет, снова же, имхо. + цена демократичная даже на нынешнее непростое время. 5. ⁠Я бы хотела больше аудирования, больше занятий на слух на занятиях.',
        socialLink: 'https://vk.com/mentally.ill.bitch',
    },
    {
        id: '5',
        image: require("../../assets/feedBackImage/NU.jpg"),
        firstName: 'Надежда',
        lastName: 'Усацкая',
        text:'В начале 9 класса, в сентябре 2024, я решила сдавать ОГЭ по английскому языку. Моя школьная учительница сказала мне, что я экзамен не сдам, но мы с Юлией стали усиленно готовиться. Занимались мы всего два раза в неделю по 1,5 часа. Мы прошли все грамматические темы, разобрали задания по аудированию и очень много времени мы уделяли подготовке к устной части экзамена.  В результате я сдала экзамен на 63 балла из 68 максимальных баллов (это твёрдая 5ка) Спасибо Юлии за мотивацию и  подготовку!',
        socialLink: 'https://vk.ru/lolitto4ka',
    },
]
// Основной компонент для отображения всех отзывов
interface FeedbackListProps {
    className?: string;
}

const FeedbackList: React.FC<FeedbackListProps> = ({ className }) => {
    return (
        <div className={`${className ?? ''} feedback-list`}>
            {feedBackData.map((feedback) => (
                <Feedback
                    key={feedback.id}
                    image={feedback.image}
                    firstName={feedback.firstName}
                    lastName={feedback.lastName}
                    status={feedback.status}
                    age={feedback.age}
                    text={feedback.text}
                    socialLink={feedback.socialLink}
                />
            ))}
        </div>
    );
};

interface FeedbackProps {
    image: string;
    firstName: string;
    lastName: string;
    status?: string;
    age?: number;
    text: string;
    socialLink?: string;
}

const Feedback: React.FC<FeedbackProps> = ({
    image,
    firstName,
    lastName,
    text,
    socialLink,
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleText = () => {
        setIsExpanded(!isExpanded);
    };
    const MAX_LENGTH = 200; // Максимальная длина текста для отображения

    return (
        <div className="feedback-list__item feedback">
        <div className="feedback__image ibg">
            <img src={image} alt={`${firstName} ${lastName}`} />
        </div>
        <div className="feedback__content">
            <h4 className="section-title blue">
            {firstName} {lastName}
            </h4>
            <p>{isExpanded ? text : `${text.substring(0, MAX_LENGTH)}...`}</p>
            <button type="button" onClick={toggleText}>
            {isExpanded ? 'Скрыть' : 'Показать весь отзыв'}
            </button>
            {socialLink && (
            <p>
                <strong>Соцсеть:</strong>{' '}
                <a href={socialLink} target="_blank" rel="noopener noreferrer">
                ВКонтакте
                </a>
            </p>
            )}
        </div>
        </div>
    );
    };

    const SocialMediaLink: React.FC = () => {
    const socialMediaStyle: React.CSSProperties = {
        position: 'fixed',
        bottom: '0%',
        right: '0%',
        zIndex: 10,
    };
    const socialMediaLinkStyle: React.CSSProperties = {
        display: 'block',
        padding: '2rem',
    };
    const socialMediaLinkStyleImage: React.CSSProperties = {
        display: 'block',
        width: '4rem',
        height: '4rem',
    };
    return (
        <div style={socialMediaStyle}>
            <a
                href={'https://wa.me/+79235089524'}
                target="_blank"
                rel="noopener noreferrer"
                style={socialMediaLinkStyle}
            >
                <span style={socialMediaLinkStyleImage}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label="WhatsApp"
                        role="img"
                        viewBox="0 0 512 512"
                        fill="none"
                    >
                        <rect width="512" height="512" rx="15%" fill="#25d366"></rect>
                        <path
                        fill="#25d366"
                        stroke="#ffffff"
                        strokeWidth="26"
                        d="M123 393l14-65a138 138 0 1150 47z"
                        ></path>
                        <path
                        fill="#ffffff"
                        d="M308 273c-3-2-6-3-9 1l-12 16c-3 2-5 3-9 1-15-8-36-17-54-47-1-4 1-6 3-8l9-14c2-2 1-4 0-6l-12-29c-3-8-6-7-9-7h-8c-2 0-6 1-10 5-22 22-13 53 3 73 3 4 23 40 66 59 32 14 39 12 48 10 11-1 22-10 27-19 1-3 6-16 2-18"
                        ></path>
                    </svg>
                </span>
            </a>
        </div>
    );
};
